import React from 'react';
import ReactDOM from 'react-dom';
import { Initializer } from 'common/types/initializers';
import { Provider } from 'react-redux';
import storeBuilder from 'reduxStore/store';
import { EmployeeWorkingHoursToggleContainer } from './container';

interface Params {
  node: HTMLElement;
}
const store = storeBuilder();

export const EmployeeWorkingHoursToggleInitializer = ({ node }: Params): Initializer => ({
  destroy: () => ReactDOM.unmountComponentAtNode(node),
  render: () => {
    ReactDOM.render(
      <Provider store={store}>
        <EmployeeWorkingHoursToggleContainer />
      </Provider>,
      node,
    );
  },
});
